import { AddOnWithQuantity } from '@/models/PackageTypes';
import { numericFormatter } from 'react-number-format';

export const formatingPrice = (price: number) => {
  return numericFormatter(price.toString(), {
    thousandSeparator: '.',
    decimalScale: 0,
    displayType: 'text',
    suffix: ' kr.',
  });
};

export const getTotalPrice = (addOns: Record<string, AddOnWithQuantity>, basePrice: number) => {
  return Object.values(addOns).reduce((acc, { addOn, quantity }) => {
    if (addOn.price) {
      return acc + addOn.price * quantity;
    }
    return acc;
  }, basePrice);
};

export const getPackageDescription = (addOns: Record<string, AddOnWithQuantity>, title: string) => {
  const packageDescription = `Pakki: ${title}`;
  const addOnDescriptions = Object.values(addOns)
    .filter(({ quantity }) => quantity > 0)
    .map(({ addOn, quantity }) => `Viðbót: ${addOn.title}, fjöldi: ${quantity}`)
    .join('\n');

  return `${packageDescription}\n${addOnDescriptions}`;
};

export const getPackageQuantity = (addOns: Record<string, AddOnWithQuantity>) => {
  return Object.values(addOns).reduce((sum, { quantity }) => sum + quantity, 0);
};
